const POST_LOGIN_REDIRECT_KEY = "vendor_portal_post_login_redirect";

const AUTH_PATH_PREFIXES = [
  "/authentication/login",
  "/auth/forgot-password",
  "/custompages",
];

const normalizeAppPath = (path = "") => {
  let normalized = String(path || "").trim();
  if (!normalized) return "";

  // Support full URLs / hash URLs from email links
  try {
    if (/^https?:\/\//i.test(normalized)) {
      const url = new URL(normalized);
      normalized = url.hash
        ? url.hash.replace(/^#/, "")
        : `${url.pathname}${url.search}`;
    } else if (normalized.startsWith("#")) {
      normalized = normalized.replace(/^#/, "");
    }
  } catch {
    // keep original
  }

  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
  if (publicUrl && normalized.startsWith(publicUrl)) {
    normalized = normalized.slice(publicUrl.length) || "/";
  }

  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }

  return normalized;
};

export const isAuthRoutePath = (pathname = "") => {
  const path = normalizeAppPath(pathname).split("?")[0].replace(/\/+$/, "") || "/";
  if (path === "/" || path === "") return true;
  return AUTH_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
};

export const buildRedirectTarget = (pathname = "", search = "") => {
  const path = normalizeAppPath(pathname);
  if (!path || isAuthRoutePath(path)) return null;

  const query = String(search || "");
  const withQuery =
    query && !path.includes("?")
      ? `${path}${query.startsWith("?") ? query : `?${query}`}`
      : path;

  return withQuery;
};

export const capturePostLoginRedirect = (pathname, search = "") => {
  const target = buildRedirectTarget(pathname, search);
  if (!target) return null;

  try {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, target);
  } catch {
    // ignore storage failures
  }
  return target;
};

export const capturePostLoginRedirectFromHash = () => {
  if (typeof window === "undefined") return null;
  const hash = window.location.hash || "";
  if (!hash || hash === "#" || hash === "#/") return null;

  const raw = hash.replace(/^#/, "");
  const [pathPart, queryPart = ""] = raw.split("?");
  return capturePostLoginRedirect(
    pathPart || "/",
    queryPart ? `?${queryPart}` : ""
  );
};

export const peekPostLoginRedirect = () => {
  try {
    const stored = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    return stored ? normalizeAppPath(stored) : null;
  } catch {
    return null;
  }
};

export const consumePostLoginRedirect = () => {
  const target = peekPostLoginRedirect();
  try {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  } catch {
    // ignore
  }
  return target && !isAuthRoutePath(target) ? target : null;
};

export const clearPostLoginRedirect = () => {
  try {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  } catch {
    // ignore
  }
};
